import { HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import { Router } from '@angular/router';
import { Response } from 'express';
import { RESPONSE } from '../token/express.tokens';

@Injectable({ providedIn: 'root' })
export class ResolverErrorService {
  constructor(
    private router: Router,
    @Optional() @Inject(RESPONSE) private response: Response | null
  ) {}

  /** Show the 404 page for the current URL without changing it. */
  showNotFound(): null {
    this.router.navigate([{ outlets: { error: ['404'] } }], {
      skipLocationChange: true,
    });
    return null;
  }

  /**
   * Route a resolver failure. A true 404 from the backend shows the
   * not-found page; anything else (rate limit, timeout, 5xx, network) is
   * rethrown so it surfaces as a server error — serving a 404 for a
   * transient failure risks de-indexing valid pages.
   */
  handle(error: unknown): null {
    if (this.getStatus(error) === 404) {
      return this.showNotFound();
    }
    // On SSR, make sure a failed render is not sent with a 200.
    this.response?.status(500);
    throw error;
  }

  private getStatus(error: unknown): number | null {
    if (error instanceof HttpErrorResponse) {
      return error.status;
    }
    // storyblok-js-client rejects with ISbError: { message, status, response }
    const status =
      (error as any)?.status ?? (error as any)?.response?.status;
    const numeric = Number(status);
    return Number.isFinite(numeric) && numeric > 0 ? numeric : null;
  }
}
